/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month,Revenue,Users
Jan,120,40
Feb,145,58`)
};

const es_line_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes,Ingresos,Usuarios
Ene,120,40
Feb,145,58`)
};

const de_line_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month,Revenue,Users
Jan,120,40
Feb,145,58`)
};

const nl_line_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maand,Omzet,Gebruikers
jan,120,40
feb,145,58`)
};

const fr_line_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mois,Revenu,Utilisateurs
Jan,120,40
Fév,145,58`)
};

const it_line_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mese,Ricavi,Utenti
Gen,120,40
Feb,145,58`)
};

const pt_br2_line_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mês,Receita,Usuários
Jan,120,40
Fev,145,58`)
};

const pt_line_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mês,Receita,Utilizadores
Jan,120,40
Fev,145,58`)
};

const ja_line_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month,Revenue,Users
Jan,120,40
Feb,145,58`)
};

const zh_line_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month,Revenue,Users
Jan,120,40
Feb,145,58`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_placeholder", locale)
	if (locale === "en") return en_line_placeholder(inputs)
	if (locale === "es") return es_line_placeholder(inputs)
	if (locale === "de") return de_line_placeholder(inputs)
	if (locale === "nl") return nl_line_placeholder(inputs)
	if (locale === "fr") return fr_line_placeholder(inputs)
	if (locale === "it") return it_line_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_line_placeholder(inputs)
	if (locale === "pt") return pt_line_placeholder(inputs)
	if (locale === "ja") return ja_line_placeholder(inputs)
	return zh_line_placeholder(inputs)
};